import ProjectCardWrapper from "./projectCard";

import { FiGithub, FiExternalLink } from "react-icons/fi";
const ProjectCard = ({
  id,
  projectImage,
  projectHeading,
  aboutProject,
  technologies,
  github,
  live,
}) => {
  return (
    <ProjectCardWrapper id={id}>
      <div className="project_card__image-section">
        <img src={projectImage} alt={projectHeading} />
      </div>

      <div className="project_card__info-section">
        <h2>{projectHeading}</h2>
        <p className="project_card__info-para">{aboutProject}</p>
        <p className="project_card__techs">{technologies}</p>

        <div className="project_card__links">
          <a
            href={github || undefined}
            target="_blank"
            rel="noreferrer"
            data-disabled={!github}
          >
            <FiGithub />
          </a>

          <a
            href={live || undefined}
            target="_blank"
            rel="noreferrer"
            data-disabled={!live}
          >
            <FiExternalLink />
          </a>
        </div>

        {/* <div className="project_card__more-btn">
          <button onClick={() => navigate("/projects")}>Show More →</button>
        </div> */}
      </div>
    </ProjectCardWrapper>
  );
};
export default ProjectCard;
